import React from "react";
import { Link } from "react-router-dom";
import SelectMultiVariant from "../../screens/NewProductScreen/SelectMultiVariant";
import MessageBox from "../../modules/shared/components/MessageBox";
import { convertToUrl } from "../../libraries/ercLibrary";
import Rating from "../Rating";
import SideProductPrice from "./SideProductPrice";
import SideProductAddToCart from "../ShortLinks/SideProductAddToCart";
import SideProductAfterAddedCart from "./SideProductAfterAddedCart";
import SideProductAfterAddedCartTypeTwo from "./SideProductAfterAddedCartTypeTwo";
import SideProductCartSummary from "./SideProductCartSummary";
import SideProductSalesCopy from "./SideProductSalesCopy";
import SideProductAddedItemsInCart from "./SideProductAddedItemsInCart";
import calculateLimitedTimeDiscountValidity from "../../utils/calculateLimitedTimeDiscountValidity";

export default function SideProductModalContent(props) {
  // PROPS COMING FROM SideProducts
  const {
    width,
    product,
    alertRef,
    addedInCartRef,
    cartSkuItems,
    variants,
    setChoosenVariants,
    choosenVariants,
    setVariantAlert,
    variantAlert,
    loadingSku,
    setNoSkuAlert,
    variantNotFound,
    addedSkus,
    setScrollHeight,
    choosenSetOfSideProducts,
    loadingCart,
    cartSkuItemsLength,
    addedInCart,
    isThereApendingOrder,
    qty,
    readyToAddNew,
    addToCartHandler,
    createdFingerPrint,
  } = props;

  return (
    <div className="side-products-section">
      <SideProductSalesCopy product={product} width={width} />

      <div className="w90p">
        <h4
          ref={alertRef}
          className="side-products-section-h4 beddo-border-bottom lh2 greenbcklight bold-font mh2-5r"
        >
          Harika bir beddo™ deneyimi için tüm seti sepete ekleyin ve alışverişi
          tamamlayın. Dilediğiniz an kolayca iade edebileciğinizi unutmayın.
        </h4>
      </div>

      <div className={width < 800 ? "w100p" : "w100p"}>
        <div className="col w100p">
          {variants.fullVariantsArray.length > 0 && (
            <h3 className="fs125 beddo-border-bottom marupsideh">
              Özellik Seçiniz
            </h3>
          )}
          <SelectMultiVariant
            singleSku={variants.singleSku}
            fullVariantsArray={variants.fullVariantsArray}
            setChoosenVariants={setChoosenVariants}
            choosenVariants={choosenVariants}
            setVariantAlert={setVariantAlert}
            variantAlert={variantAlert}
            loadingSku={loadingSku}
            setNoSkuAlert={setNoSkuAlert}
          />
        </div>
      </div>
      {variantNotFound && (
        <div className={width < 800 ? "w90p margintop-5" : "w90p margintop-5"}>
          <MessageBox variant="info">
            <p className="fs-85 txtcenter">
              Seçtiğiniz özellikte ürün mevcut değil ise seçiminizden farklı
              özellikte ürünler görebilirsiniz.
            </p>
          </MessageBox>
        </div>
      )}
      <div className="col marupside1 lightbeddobck w90p shadow-light">
        {addedSkus && addedSkus.length > 0 && (
          <h3
            className="fs125 beddo-border-bottom lightbck w100p txtcenter"
            ref={addedInCartRef}
          >
            Sepete Eklediğiniz Set Ürünleri
          </h3>
        )}

        <SideProductAddedItemsInCart
          addedSkus={addedSkus}
          width={width}
          isThereApendingOrder={isThereApendingOrder}
          createdFingerPrint={createdFingerPrint}
        />

        {addedSkus && addedSkus.length > 0 && (
          <SideProductCartSummary
            addedSkus={addedSkus}
            setScrollHeight={setScrollHeight}
            width={width}
          />
        )}
      </div>
      <div className="side-products-outer-flex">
        {choosenSetOfSideProducts &&
          choosenSetOfSideProducts.length > 0 &&
          choosenSetOfSideProducts.map((choosen, index) => {
            // CHECK LIMITED TIME DISCOUNT VALIDITY
            const { isDiscountValid, remainingTime } =
              calculateLimitedTimeDiscountValidity(
                choosen,
                createdFingerPrint.firstVisitTime
              );

            return (
              <div key={index} className="side-products-container-wrapper">
                {cartSkuItems.length > 0 &&
                cartSkuItems[0].product === choosen.productId ? (
                  <SideProductAfterAddedCartTypeTwo
                    index={index}
                    setScrollHeight={setScrollHeight}
                    choosen={choosen}
                    cartSkuItems={cartSkuItems}
                    width={width}
                    loadingCart={loadingCart}
                    cartSkuItemsLength={cartSkuItemsLength}
                    addedInCartRef={addedInCartRef}
                  />
                ) : addedInCart.some((item) => item === choosen.productId) ? (
                  <SideProductAfterAddedCart
                    index={index}
                    setScrollHeight={setScrollHeight}
                    choosen={choosen}
                    cartSkuItems={cartSkuItems}
                    width={width}
                    loadingCart={loadingCart}
                    cartSkuItemsLength={cartSkuItemsLength}
                    addedInCartRef={addedInCartRef}
                  />
                ) : (
                  <div
                    key={index}
                    className="side-products-container"
                    onClick={() => setScrollHeight("/urun")}
                  >
                    <Link
                      to={`/urun/${convertToUrl(choosen.productName)}/${
                        choosen.productId
                      }`}
                    >
                      <img
                        className="side-products-image"
                        src={choosen.skuImages[0]}
                        alt={choosen.name}
                      />
                    </Link>
                    <div className="side-products-name">{choosen.name}</div>
                    <Rating
                      value={choosen.rating}
                      text={choosen.numReviews}
                      hover={false}
                    />

                    <SideProductPrice
                      isThereApendingOrder={isThereApendingOrder}
                      qty={qty}
                      choosen={choosen}
                      cartSkuItems={cartSkuItems}
                      isDiscountValid={isDiscountValid}
                      remainingTime={remainingTime}
                    />

                    <SideProductAddToCart
                      readyToAddNew={readyToAddNew}
                      addToCartHandler={addToCartHandler}
                      choosen={choosen}
                      isDiscountValid={isDiscountValid}
                      variantAlert={variantAlert}
                      index={index}
                      alertRef={alertRef}
                    />
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}
